module.exports = __webpack_public_path__ + "static/media/2.5513d220.jpeg";